import { useEffect, useRef } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';
import { navDirection, prefersReducedMotion, setNavDirection } from '../lib/motion';

/** Scroll window to top on every route change (instant — pairs with page transition). */
export function ScrollToTop() {
  const { pathname } = useLocation();
  const navType = useNavigationType();
  const prevPath = useRef(pathname);

  useEffect(() => {
    if (prevPath.current !== pathname) {
      setNavDirection(navDirection(prevPath.current, pathname));
      prevPath.current = pathname;
    }
    // POP (back/forward) keeps scroll restoration feel; PUSH/REPLACE jump to top.
    if (navType === 'POP') return;
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname, navType]);

  return null;
}

/** Same-route Home / logo: ease back to the top so the jump is felt, not jarring. */
export function scrollWindowToTop() {
  if (prefersReducedMotion()) {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    return;
  }
  window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
}
